import gql from 'graphql-tag';

export const GET_DYNAMIC_LENDER_MAPPING = gql`
  query MappedLenderValuesForVendorOpportunity(
    $lenderType: LenderType!
    $vendorOpportunityId: ID!
    $lenderProfileDynamicsId: ID!
  ) {
    getMappedLenderValuesForVendorOpportunity(
      lenderType: $lenderType
      vendorOpportunityId: $vendorOpportunityId
      lenderProfileDynamicsId: $lenderProfileDynamicsId
    ) {
      lenderFieldId
      lenderProperty
      mappedValue
      originalMappedValue
      details {
        displayName # String
        section # Used to order inputs
        category # Used to order inputs within sections
        dcrPropertySource # String
        fieldInputType # String
        required # RequiredStatusType - REQUIRED, OPTIONAL, CONDITIONAL
        notesInternal # String
        notesExternal # String
        hidden # Boolean
        readOnly # Boolean
        rulesConfiguration # JSON
        ordinal
        lenderFieldParentId
        lenderFieldParentLenderProperty
        validRegexPattern
        inputErrorHelperText
        optionSets {
          displayName
          lenderFieldId
          lenderFieldOptionSetId
          lenderFieldOptionSetParentId
          lenderValue
        }
      }
    }
  }
`;
